import { useState } from 'react';
import MainProductGroupModel from './MainProductGroup';
import PowerBiMainProductGroup from './PowerBiMainProductGroup';
import SalesDepartmentModel from './SalesDepartment';

const productGroupModel = () => {
  const initialState = {
    id: '',
    productGroupCode: '',
    productGroupName: '',
    catalogueNo: '',
    salesDepartment: SalesDepartmentModel().initialState,
    mainProductGroup: MainProductGroupModel().initialState,
    powerBiMainProductGroup: PowerBiMainProductGroup().initialState,
  };

  const [productGroup, setProductGroup] = useState(initialState);

  return { productGroup, setProductGroup, initialState };
};

export default productGroupModel;
